export default __webpack_public_path__ + "static/media/heart.ffbaf6ce.svg";